module.exports = __webpack_public_path__ + "static/media/rocketppe_3ply_mob.93f3d019.jpg";